<template>
  <div>
    <sign-up-form
      v-if="currentStep === 1"
      @submit="sendVerificationCode"
      :email="email"
    />
    <verify-email-form
      v-else
      @submit="signup"
      @resend="resendCode"
      :loading="signingUp"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SignUpForm from "./SignUpForm";
import VerifyEmailForm from "./VerifyEmailForm";
export default {
  components: {
    SignUpForm,
    VerifyEmailForm,
  },
  props: ["email"],
  data: () => ({
    form: {},
    currentStep: 1,
    signingUp: false,
  }),
  computed: {
    ...mapGetters({
      signupInfo: "auth/signup",
      isAuthenticated: "auth/isAuthenticated",
    }),
  },
  methods: {
    async sendVerificationCode(payload) {
      this.form = payload;
      await this.$store.dispatch("auth/verifySignupEmail", payload.email);
      if (this.signupInfo.codeSent) {
        this.currentStep = 2;
      }
    },
    async resendCode() {
      await this.$store.dispatch("auth/verifySignupEmail", this.form.email);
      this.$store.dispatch("addAlert", {
        type: "success",
        title: "Success",
        message: "auth.signup.verification.sent",
      });
    },
    async signup(code) {
      this.signingUp = true;
      await this.$store.dispatch("auth/signup", {
        ...this.form,
        emailCode: code,
      });
      if (!this.signupInfo.error) {
        await this.$store.dispatch("auth/login", {
          email: this.form.email,
          password: this.form.password,
        });
        this.$store.dispatch("closeAuthModal");
        this.$store.dispatch("addAlert", {
          type: "success",
          title: "auth.signup.success.title",
          message: "auth.signup.success.message",
        });
        setTimeout(() => {
          this.$store.dispatch("showSelectWalletModal");
        }, 500);
      }
      this.signingUp = false;
    },
  },
};
</script>